import 'react';

var locationImg = "https://shopfront-cdn.tekoapis.com/static/f18a4fe05e264d9e.svg";

export { locationImg as default };
